module.exports = __webpack_public_path__ + "static/media/zimbara-mobile.5816c8c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/mobile/zimbara-mobile.png
// module id = 253
// module chunks = 0